<script>
  import { dataInfo } from "../../editor/storage.js";
  import { dTypeIcon } from "../../editor/component/data.js";
  export let x = "290px",
    y = "350px",
    field,
    selected,
    selectAction;
  let panel;
  function adjustPosition(node) {
    let moved = {};

    node.addEventListener("mousedown", (event) => {
      // start
      if (event.target.classList.contains("window-drag")) {
        moved.ing = true;
        moved.ox = event.clientX;
        moved.oy = event.clientY;
        moved.px = parseFloat(panel.style.left);
        moved.py = parseFloat(panel.style.top);
      }
    });
    window.addEventListener("mouseup", (event) => {
      moved.ing = false;
    });
    window.addEventListener("mousemove", (event) => {
      if (moved.ing) {
        moved.dx = event.clientX - moved.ox;
        moved.dy = event.clientY - moved.oy;
        node.style.left = moved.px + moved.dx + "px";
        node.style.top = moved.py + moved.dy + "px";
      }
    });
  }
</script>

{#if field && field.length > 0}
  <div
    class="dupo-menu-pane dupo-third-panel"
    style={`left: ${x}; top: ${y}; width: 274px;`}
    bind:this={panel}
    use:adjustPosition
  >
    <div class="dupo-menu-pane-row pt-2">
      <h3 class="window-drag">
        <i class="bi bi-card-list me-1" /> Field preview: {field}
      </h3>
    </div>
    <div class="dupo-menu-pane-row pb-2">
      Type: <i
        class={`bi bi-${dTypeIcon[$dataInfo.stats[field]?.type]} ms-1 me-1`}
      />
      {$dataInfo.stats[field]?.type}
    </div>
    {#if $dataInfo.stats[field]?.type === "nominal" || $dataInfo.stats[field]?.type === "ordinal"}
      <div class="dupo-menu-pane-row pb-2">Values:</div>
      <div class="dupo-menu-pane-form-row mb-2">
        <div class="custom-form-select">
          {#if selected !== undefined && selectAction !== undefined}
            {#each $dataInfo.stats[field].values as val}
              {#if val !== undefined}<div
                  on:click={() => {
                    selectAction(val);
                  }}
                  class={selected.includes(val) ? "selected" : ""}
                >
                  {#if selected.includes(val)}<i
                      class="bi bi-check me-1"
                    />{/if}
                  {val}
                </div>{/if}
            {/each}
          {:else}
            {#each $dataInfo.stats[field].values as val}
              {#if val !== undefined}<div>{val}</div>{/if}
            {/each}
          {/if}
        </div>
      </div>
    {:else}
      <div class="dupo-menu-pane-row pb-2">
        Range: {$dataInfo.stats[field]?.min} – {$dataInfo.stats[field]?.max}
      </div>
    {/if}
  </div>
{/if}

<style>
  .selected {
    background-color: rgba(110, 250, 30, 0.2);
  }
</style>
